<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">Fraud Prevention Policy</h1>
        <p class="desc-text">Effective Date: August 5, 2025</p>

        <section class="content-section">
            <p class="desc-text">XigCheck implements anti-fraud and marketplace integrity measures for certain high-value product categories.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">1. Fake Seller Detection</h2>
            <p class="desc-text">The platform may review:</p>
            <ul class="policy-list">
                <li>Seller identity verification</li>
                <li>Account integrity checks</li>
                <li>Product listing behavior analysis</li>
                <li>Risk-based monitoring procedures</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">2. Suspicious Transaction Review</h2>
            <p class="desc-text">Transactions or product information may be flagged for additional review due to:</p>
            <ul class="policy-list">
                <li>Unusual product listing behavior</li>
                <li>Inconsistent product information</li>
                <li>Unusual transaction activity</li>
                <li>Repeat policy violations</li>
                <li>Product information review</li>
                <li>Manual compliance check</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">3. Repeat Offender Monitoring</h2>
            <p class="desc-text">Accounts associated with repeated suspicious behavior may be subject to:</p>
            <ul class="policy-list">
                <li>Access restrictions</li>
                <li>Account suspension</li>
                <li>Removal from platform access</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">4. Marketplace Integrity and Cooperation</h2>
            <p class="desc-text">XigCheck reserves the right to decline authentication review requests or restrict platform access when fraud risk, policy violations, or marketplace integrity concerns are identified.</p>
            <p class="desc-text">Anti-fraud procedures may involve collaboration with the following entities:</p>
            <ul class="policy-list">
                <li>Marketplace trust and security systems</li>
                <li>Identity verification procedures</li>
                <li>Independent service providers</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">5. No Financial Protection Services</h2>
            <p class="desc-text">Anti-fraud procedures are for operational trust and security purposes only and do not constitute financial protection or insurance services.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckFraudPreventionPolicy'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
